import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edd21e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desire-to-work p-3" }
const _hoisted_2 = { class: "py-2 mb-3" }
const _hoisted_3 = { class: "rule-list" }
const _hoisted_4 = { class: "text-weight-500 text-green text-size-14 mb-1 caution" }
const _hoisted_5 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_FormRadioGroup = _resolveComponent("FormRadioGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      転職意欲\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("dl", _hoisted_3, [
          _createElementVNode("dt", _hoisted_4, [
            _createVNode(_component_FeatherIcon, {
              icon: "info",
              size: "16",
              class: "caution-icon"
            }),
            _createTextVNode("「条件を聞いてみたい」「面接を受けたい」を選択した場合、スカウトメッセージや限定求人が届くことがあります\n          ")
          ])
        ])
      ]),
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, { ref: "vObserver" }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BForm, {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ValidationProvider, {
                  name: "転職意欲",
                  rules: { required: true },
                  vid: "desireToWork"
                }, {
                  default: _withCtx((validationState) => [
                    _createVNode(_component_FormRadioGroup, {
                      label: "転職意欲",
                      appLabelText: "必須",
                      name: "desireToWork",
                      modelValue: _ctx.desireToWork,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.desireToWork) = $event)),
                      options: _ctx.desireToWorkOptions,
                      "validation-state": validationState
                    }, null, 8, ["modelValue", "options", "validation-state"])
                  ]),
                  _: 1
                })
              ]),
              _createTextVNode(),
              _createVNode(_component_AppButton, {
                block: true,
                class: "mt-4",
                onClick: ($event: any) => (handleSubmit(_ctx.onClickSubmitButton))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登録する")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick"])
            ], undefined, true),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 512)
    ])
  ]))
}